import deepmerge from "@node/deepmerge";

let locales = {};
const modules = import.meta.glob("@o-din-ppr/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-ppr/src/ppr/store.js";
import menu from "@o-din-ppr/src/ppr/menu.json";

export default {
  routes: [
    { path: "/ppr/disaggregation_numbers", component: () => import("./ppr/disaggregation_numbers/Index.vue") },
    { path: "/ppr/disaggregation_numbers/new", component: () => import("./ppr/disaggregation_numbers/Form.vue") },
    { path: "/ppr/disaggregation_numbers/:id/edit", component: () => import("./ppr/disaggregation_numbers/Form.vue") },
    { path: "/ppr/issues/", component: () => import("./ppr/issues/Index.vue") },
    { path: "/ppr/issues/archive", component: () => import("./ppr/issues/Archive.vue") },
    { path: "/ppr/issues/:id", component: () => import("./ppr/issues/Show.vue") },
    { path: "/ppr/checklists/", component: () => import("./ppr/checklists/Index.vue") },
    { path: "/ppr/checklists/new", component: () => import("./ppr/checklists/FormElement.vue") },
    { path: "/ppr/checklists/:id/edit", component: () => import("./ppr/checklists/FormElement.vue") },
    { path: "/ppr/checklists/:id", component: () => import("./ppr/checklists/Show.vue") },
    { path: "/ppr/calendar", component: () => import("./ppr/calendar/Index.vue") },
    { path: "/ppr/group_systems", component: () => import("./ppr/group_systems/Index.vue") },
    { path: "/ppr/group_systems/new", component: () => import("./ppr/group_systems/Form.vue") },
    { path: "/ppr/group_systems/:id/edit", component: () => import("./ppr/group_systems/Form.vue") },
    { path: "/ppr/systems", component: () => import("./ppr/systems/Index.vue") },
    { path: "/ppr/systems/:id/manage", component: () => import("./ppr/systems/Manage.vue") },
    { path: "/ppr/systems/new", component: () => import("./ppr/systems/Form.vue") },
    { path: "/ppr/systems/:id/edit", component: () => import("./ppr/systems/Form.vue") },
    { path: "/ppr/equipments", component: () => import("./ppr/equipments/Index.vue") },
    { path: "/ppr/equipments/new", component: () => import("./ppr/equipments/Form.vue") },
    { path: "/ppr/equipments/:id/edit", component: () => import("./ppr/equipments/Form.vue") },
    { path: "/ppr/equipments/:id/print", component: () => import("./ppr/equipments/form/technological_map/print.vue") },
    { path: "/ppr/equipments/print_qr", component: () => import("./ppr/equipments/EquipmentQr.vue") },
    { path: "/ppr/equipment_works", component: () => import("./ppr/equipment_works/Index.vue") },
    { path: '/ppr/works', component: () => import("./ppr/works/Index.vue") },
    { path: '/ppr/works/new', component: () => import("./ppr/works/Form.vue") },
    { path: '/ppr/works/:id/edit', component: () => import("./ppr/works/Form.vue") },
    { path: '/ppr/frequency_works', component: () => import("./ppr/frequency_works/Index.vue") },
    { path: '/ppr/frequency_works/new', component: () => import("./ppr/frequency_works/Form.vue") },
    { path: '/ppr/frequency_works/:id/edit', component: () => import("./ppr/frequency_works/Form.vue") },
    { path: '/ppr/work_assignments', component: () => import("./ppr/work_assignment/Index.vue") }
  ],
  locales,
  store,
  menu: [menu]
};
